<template>
  <v-container
    fluid
    class="pa-0 ma-0 d-flex flex-column justify-center align-center"
  >
    <v-img
      src="@/assets/images/header_image.svg"
      class="fluid-max-width-login my-2 my-md-6"
      width="100%"
    />
    <v-container class="fluid-max-width-login pa-6 text-center">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="login">
          <validation-provider
            v-slot="{ errors }"
            name="email"
            rules="required|email"
            mode="lazy"
          >
            <v-text-field
              v-model="email"
              :error-messages="errors"
              label="E-Mail"
              name="email"
              type="email"
              autocomplete="username email"
              required
              single-line
              prepend-inner-icon="mdi-account"
            ></v-text-field>
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            name="password"
            rules="required"
          >
            <v-text-field
              v-model="password"
              :error-messages="errors"
              label="Passwort"
              name="password"
              type="password"
              autocomplete="current-password"
              required
              single-line
              prepend-inner-icon="mdi-lock"
            ></v-text-field>
          </validation-provider>
          <v-btn
            color="primary"
            class="mt-6"
            width="200"
            type="submit"
            :disabled="invalid"
            depressed
          >
            Login
          </v-btn>
        </form>
      </validation-observer>
      <p class="mt-4" v-if="errorMessage">
        {{ errorMessage }}
      </p>
      <p class="mt-6 pt-4">
        <router-link to="/passwort-reset">Passwort vergessen</router-link>
      </p>
      <p class="mt-2">
        <router-link to="/impressum">Impressum</router-link>
      </p>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  components: {},
  data: () => ({
    email: '',
    password: '',
    errorMessage: '',
    invalid: false,
  }),
  methods: {
    ...mapActions(['autoLogin', 'userLogin']),
    async login() {
      this.errorMessage = '';
      try {
        const success = await this.userLogin({
          email: this.email,
          password: this.password,
        });
        if (!success)
          this.errorMessage = 'Benutzername oder Passwort ist ungültig.';
      } catch (e) {
        this.errorMessage = e.message;
      }

      if (window.PasswordCredential) {
        // eslint-disable-next-line no-undef
        var c = new PasswordCredential({
          password: this.password,
          id: this.email,
        });
        navigator.credentials.store(c);
      }
    },
  },
};
</script>

<style scoped>
.fluid-max-width-login {
  max-width: 500px;
}
</style>
